import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import * as SaldosInicialesCrud from 'services/saldosIniciales.service'

import ImportarExcelModal from './modals/importarExcel'

import { DownloadAxiosFile } from 'utils'

const portletBreadcrumbs = [{ name: 'Saldos Iniciales' }]

const SaldosInicialesListaPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)

  const [mostrarImportarExcelModal, setMostrarImportarExcelModal] = React.useState(false)

  const clickEditar = React.useCallback(
    async ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.SALDOSINICIALES_NUEVO}/${_id}`)
    },
    [history]
  )

  const clickNuevoHandler = e => {
    e.preventDefault()
    history.push(`/${CodigosTransaccionesConstant.SALDOSINICIALES_NUEVO}`)
  }

  const clickEdicionPorGrupoHandler = e => {
    e.preventDefault()
    history.push(`/${CodigosTransaccionesConstant.SALDOSINICIALES_EDITARPORGRUPO}`)
  }

  const clickDescargarReporteHadler = () => {
    SaldosInicialesCrud.getReporte()
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  const clickImportarExcelHandler = () => {
    setMostrarImportarExcelModal(true)
  }

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Saldos Iniciales'
          breadcrumbs={portletBreadcrumbs}
          buttons={[
            { name: 'Descargar Reporte', onClick: clickDescargarReporteHadler },
            { name: 'Importar Excel', onClick: clickImportarExcelHandler },
            { name: 'Edición por Grupo', onClick: clickEdicionPorGrupoHandler },
            { name: 'Nuevo', onClick: clickNuevoHandler }
          ]}
        />
        <Portlet.Body>
          <Table.ServerSide
            useNest={true}
            ref={tablaRef}
            url='/kardex'
            baseParams={{
              tipoConsulta: 'saldos-iniciales'
            }}
            headRows={[{ label: 'TITULO' }, { label: 'FECHA' }, { label: 'DOCUMENTO' }, { label: '' }]}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell>{row.titulo || '--'}</Table.Cell>
                <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
                <Table.Cell>{`${row.tipoDocumento} - ${row.serieDocumento} - ${row.numeroDocumento}`}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                        Editar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarImportarExcelModal && (
        <ImportarExcelModal
          handleClose={e => setMostrarImportarExcelModal(false)}
          show={mostrarImportarExcelModal}
          reloadTable={tablaRef.current.reload}
        />
      )}
    </>
  )
}

export default SaldosInicialesListaPage
